import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function cancelMission(id: number) {
  return restApiClient.url(constructApiUrl(API.missions.cancelMission.url, { id })).post()
}
